<template>
  <v-card
    class="mx-auto"
    max-width="90%"
    outlined
  >
  
    <v-card-text>
  <v-row>
  <v-col class="mx-auto" cols="12" sm="10" md="10">
    <v-skeleton-loader v-if="isLoading" type="card" class="mx-auto" max-width="90%"/>

    <v-alert v-if="!isLoading" type="error" class="mx-auto col-6" justify="center"  >
      Por motivos de seguridad el enlace es de un solo uso y ha caducado
    </v-alert>
  </v-col>
  </v-row>
      </v-card-text>

  </v-card>

</template>

<script>
import api from '../services/solicitudService' 

  export default {
      name: 'InternalRedirect', 
    data () {
      return {
       isLoading: true,
       tokenGestion: null,
       tokenRedirect: null, 
       idNotificacionOrigen: null,
      }
    },
    methods: {
      redirect: function() {
        this.$store.commit('solicitud/setTokenGestion', '');
        api.getInternalRedirect(this.tokenRedirect, res => {
          
          this.tokenGestion = res;

          if (this.tokenGestion) {
            this.$store.commit('solicitud/setTokenGestion', this.tokenGestion);
            this.getSolicitante();
          }
          else {
            this.isLoading = false; 
          }
        },
        error => {
          this.isLoading = false; 
          console.log(error);
        });
      },
      getSolicitante: function () {
        api.getSolicitanteInterno(this.tokenGestion, res => {
          var me = this;

          if (res != null) {
            res.tramiteEnviado = null;
            res.ultimoPaso=null;
            
            me.$store.commit('solicitud/setSolicitante', res);
            me.$store.commit('solicitud/setTokenAcceso', res.token);
            me.$store.commit('solicitud/setTotalNotificaciones', 0);
            me.$store.commit('solicitud/SET_ID_NOTIFICACION', me.idNotificacionOrigen);
						this.$router.push({ name: 'complete-redirect' });
            
          }
          else {
            this.isLoading = false;
          }
        },
        error => {
          this.isLoading = false;
          console.log(error);
        }
      )} 
    },
    watch: {
      $route(to) {
        console.log('internal-redirect', to.params);
        this.tokenRedirect = to.params.internalToken;
        if (to.params.internalNotificacion) {
          this.idNotificacionOrigen = to.params.internalNotificacion;
        } 
        this.redirect();
      },
     
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        console.log('internal-redirect', to.params);
        vm.tokenRedirect = to.params.internalToken;
        if (to.params.internalNotificacion) {
          vm.idNotificacionOrigen = to.params.internalNotificacion;
        } 
        vm.redirect();
      })
    }
  }
</script>